<script setup>
import { computed } from 'vue'
import Avatar from 'primevue/avatar'
import ProgressBar from 'primevue/progressbar'

const props = defineProps({
    worker: { type: Object, required: true },
    color:  { type: String, default: '#2A6FDB' },
})

const pct = computed(() => Math.min(100, Math.round((props.worker.booked / props.worker.capacity) * 100)))
</script>

<template>
    <div class="flex items-center gap-2.5 py-2">
        <Avatar
            :label="worker.initials"
            shape="circle"
            :style="{ width: '26px', height: '26px', minWidth: '26px', background: color, color: 'white', fontSize: '10px', fontWeight: 'bold' }"
        />
        <div class="flex-1 min-w-0">
            <div class="flex items-baseline justify-between mb-1.5">
                <span class="text-[13px] font-semibold text-gray-900 dark:text-white truncate">{{ worker.name }}</span>
                <span class="text-[12px] text-gray-400 dark:text-neutral-500 font-semibold ml-2 flex-shrink-0">
                    {{ worker.booked }}/{{ worker.capacity }} h · {{ pct }}%
                </span>
            </div>
            <ProgressBar
                :value="pct"
                :show-value="false"
                :pt="{ root: { style: { height: '7px', borderRadius: '9999px' } }, value: { style: { background: color, borderRadius: '9999px' } } }"
            />
        </div>
    </div>
</template>
